export default {
    url: '/list',
    template: '<forms-settings-questioncategories-list></forms-settings-questioncategories-list>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/forms/settings/questioncategories/list/index.js